module.exports = __webpack_public_path__ + "static/home-bb6fec54312927df8c7ce9a192196bf8.jpg";